import React, { useEffect, useRef } from 'react'
import 'plyr/dist/plyr.css'

export type Video = {
  src: string
  poster?: string
  videoControls?: string[]
  autoPlay?: boolean
  loop?: boolean
}

export const MlVideoPlayer: React.FC<Video> = ({ src, poster, videoControls, autoPlay = false, loop = false }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const playerRef = useRef<any>(null)

  useEffect(() => {
    let mounted = true

    const loadPlyr = async () => {
      const Plyr = (await import('plyr')).default

      if (videoRef.current && mounted) {
        playerRef.current = new Plyr(videoRef.current, {
          controls: autoPlay
            ? []
            : videoControls ?? [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'settings',
                'pip',
                'fullscreen',
              ],
        })

        if (autoPlay) {
          playerRef.current.muted = true
          playerRef.current.volume = 0
          playerRef.current.play()
        }
      }
    }

    loadPlyr()

    return () => {
      mounted = false
      playerRef.current?.destroy()
    }
  }, [autoPlay, videoControls])

  useEffect(() => {
    if (playerRef.current && src) {
      playerRef.current.source = {
        type: 'video',
        sources: [{ src, type: 'video/mp4' }],
        poster,
      }
    }
  }, [src, poster])

  return (
    <video ref={videoRef} poster={poster} loop={loop} preload="auto" controls style={{ width: '100%' }}>
      <source src={src} type="video/mp4" />
    </video>
  )
}
